export const BASE_URL = process.env.REACT_APP_SERVICE_REQUEST_URL || 'https://31im0crjoa.execute-api.us-east-1.amazonaws.com/dev';
export const EXTERNAL_IDENTITY_NAME = process.env.REACT_APP_EXTERNAL_IDENTITY_NAME || 'nsi-integrations';
export const CUSTOMER_OWNED_PRODUCT_IDS = process.env.REACT_APP_CUSTOMER_OWNED_PRODUCT_IDS || 'PC-GUEST';
export const DYNATRACE_RUM_SRC = process.env.REACT_APP_DYNATRACE_RUM_SRC;
export const CUSTOMER_NAME_PLACEHOLDER = 'Not Given';

//views
export const STORE_VIEW: string = 'STORE_VIEW';
export const CUSTOMER_OWNED_VIEW: string = 'CUSTOMER_OWNED_VIEW';
export const SPECIAL_ORDER_VIEW: string = 'SPECIAL_ORDER_VIEW';
export const CUSTOMER_VIEW: string = 'CUSTOMER_VIEW';
export const PRODUCT_TYPES = [
    { name: "Bracelets", value: "Bracelets" },
    { name: "Charms", value: "Charms" },
    { name: "Earrings", value: "Earrings" },
    // { name: "Handbags", value: "Handbags" },
    { name: "Misc", value: "Misc" },
    { name: "Necklaces & Chains", value: "Necklaces & Chains" },
    { name: "Pendants", value: "Pendants" },
    { name: "Rings", value: "Rings" }
];
export const FILTER_STORAGE_KEY = 'storeViewFilters';
export const STORE_VIEW_SCROLL_KEY = 'storeViewScrollState';
